var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0065 19.0065H19.9532L19.5798 18.6465C20.8865 17.1265 21.6732 15.1532 21.6732 13.0065C21.6732 8.21984 17.7932 4.33984 13.0065 4.33984C8.21984 4.33984 4.33984 8.21984 4.33984 13.0065C4.33984 17.7932 8.21984 21.6732 13.0065 21.6732C15.1532 21.6732 17.1265 20.8865 18.6465 19.5798L19.0065 19.9532V21.0065L25.6732 27.6598L27.6598 25.6732L21.0065 19.0065ZM13.0065 19.0065C9.68651 19.0065 7.00651 16.3265 7.00651 13.0065C7.00651 9.68651 9.68651 7.00651 13.0065 7.00651C16.3265 7.00651 19.0065 9.68651 19.0065 13.0065C19.0065 16.3265 16.3265 19.0065 13.0065 19.0065ZM12.3398 12.3398V9.67318H13.6732V12.3398H16.3398V13.6732H13.6732V16.3398H12.3398V13.6732H9.67318V12.3398H12.3398Z",
    fillOpacity: 0.87,
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.dbce8cd0e905a65abb69aaa21392303c.svg";
export { ForwardRef as ReactComponent };